import { render, staticRenderFns } from "./DialogCopyrightNotice.vue?vue&type=template&id=002108f5"
import script from "./DialogCopyrightNotice.vue?vue&type=script&lang=js"
export * from "./DialogCopyrightNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports